import { formatLongDate } from '../dateOnly';

// Dates are YYYY-MM-DD strings, so lexical comparison is date comparison.
export function coverageStatus(p, today) {
  if (!p || p.isActive === false) return { label: 'Inactive', tone: 'neutral' };
  if (p.terminationDate && p.terminationDate < today) return { label: `Ended ${formatLongDate(p.terminationDate)}`, tone: 'bad' };
  if (p.effectiveDate && p.effectiveDate > today) return { label: `Starts ${formatLongDate(p.effectiveDate)}`, tone: 'warn' };
  if (p.terminationDate) return { label: `Active until ${formatLongDate(p.terminationDate)}`, tone: 'good' };
  return { label: 'Active', tone: 'good' };
}

export function authorizationWarning(p) {
  return p && p.authorizationSignedOn ? null : 'No signed insurance authorization on file. Claims stay blocked until the office records the signed date.';
}

const REL = { self: 'Self', spouse: 'Spouse', child: 'Child', other: 'Other' };
export function relationshipLabel(code) {
  return REL[code] || 'Other';
}

export function policyHeadline(p) {
  const pri = p.priority === 'secondary' ? 'Secondary' : 'Primary';
  const id = p.memberId ? p.memberId : (p.memberIdLast4 ? `••••${p.memberIdLast4}` : '—');
  return `${p.payerName} · ${pri} · ID ${id}`;
}
